import {
  sapStatus,
  type SapStatus,
  type VivaOrSapStatus,
  type VivaStatus,
  vivaStatus as vivaStatusOptions,
} from '../dtos.ts';
import { content } from './content.ts';

const UNKNOWN_STATUS = 'UNKNOWN_STATUS';

const statusLabels: Record<VivaOrSapStatus | typeof UNKNOWN_STATUS, string> = {
  [vivaStatusOptions.IN_PLANUNG]: content.vivaStatus.inPlanung,
  [vivaStatusOptions.ABGESCHLOSSEN]: content.vivaStatus.abgeschlossen,
  [vivaStatusOptions.FREIGEGEBEN]: content.vivaStatus.freigegeben,
  [vivaStatusOptions.IM_AUSSCHREIBUNGSPORTAL]: content.vivaStatus.imAusschreibungsportal,
  [sapStatus.ABGESAGT]: sapStatus.ABGESAGT,
  [sapStatus.FIXIERT]: sapStatus.FIXIERT,
  [sapStatus.GEPLANT]: sapStatus.GEPLANT,
  [sapStatus.GESPERRT]: sapStatus.GESPERRT,
  [UNKNOWN_STATUS]: content.noInfoAvailable,
};

export function determineStatusText(status: SapStatus | null, vivaStatus: VivaStatus | null): string;
export function determineStatusText(status: VivaOrSapStatus | null): string;
export function determineStatusText(status: VivaOrSapStatus | null, vivaStatus?: VivaStatus | null): string {
  return statusLabels[status ?? vivaStatus ?? UNKNOWN_STATUS];
}
